module.exports = __webpack_public_path__ + "static/media/cancelLogo.5fd9fc45.svg";